import { fetch_query_data } from "@/api/query_data"
import { LoadingSpinner } from "@/app/loading"
import { UserState } from "@/auth/user"
import { TableState } from "@/deduction_table/table_state"
// import { putTransactionType } from "@/deductions/table/transaction_type"
import { currencyFormatter, isSuperCoffeeUser, useAsyncEffect } from "@/utils"
import { BarList } from "@tremor/react"
import { useState } from "preact/hooks"
import { Bar } from "./StatusBreakdown.tsx"
import { GlobalFilterState, analytics_date_kind } from "@/global_filter"
import { notifyChartFilterApplied } from "@/utils/filter_feedback"

type ReasonCodeData = {
  name: string
  value: number
  amount: number
  color: string
}

const LIKELIHOOD_COLORS = {
  red: "red",
  yellow: "yellow",
  green: "green",
}

export function ReasonCodeBreakdownByFlag() {
  const [data, setData] = useState<ReasonCodeData[]>([])
  const [loading, setLoading] = useState(true)
  const [start, end, distributor, dateKind] = GlobalFilterState.use(s => [
    s.startDate,
    s.endDate,
    s.distributor,
    s.dateKind,
  ])
  const user = UserState.use()

  useAsyncEffect(async () => {
    // Only fetch for specific org_id
    if (!user || !isSuperCoffeeUser(user.org_id)) {
      setLoading(false)
      return
    }

    let res = await fetch_query_data("reason_code_breakdown_by_flag", {
      start,
      end,
      distributor: distributor === "All Distributors" ? null : distributor,
      date_kind: analytics_date_kind(dateKind),
    })
    setLoading(false)
    if (!res.ok) {
      setData([])
      return
    }

    const { rows } = res.value
    const processedData = rows.map(row => ({
      name: `${row[0]} (${row[2]})`, // custom_category (count)
      value: row[2] as number, // count
      amount: row[3] as number, // total_amount
      color:
        LIKELIHOOD_COLORS[String(row[1]).toLowerCase() as keyof typeof LIKELIHOOD_COLORS] || "gray",
      key: `${row[0]}-${row[1]}`, // For unique identification
    }))

    setData(processedData)
  }, [start, end, distributor, dateKind, user?.org_id])

  if (loading) {
    return <LoadingSpinner />
  }

  if (!data.length || !user || !isSuperCoffeeUser(user.org_id)) {
    return null
  }

  return (
    <div class="flex">
      <BarList
        data={data}
        className="max-w-2xl grow"
        sortOrder="none"
        valueFormatter={(_: ReasonCodeData) => ""}
        onValueChange={(item: Bar<ReasonCodeData>) => {
          const reasonCode = item.key!.split("-")[0]!
          TableState.set(s => {
            return {
              ...s,
              search: "",
              // transactionTypes: putTransactionType(s.transactionTypes, "deduction"),
              columnFilters: [{ id: "custom_category", value: reasonCode }],
              pagination: { pageIndex: 0, pageSize: s.pagination.pageSize },
            }
          })
          notifyChartFilterApplied(`Showing deductions with reason code "${reasonCode}".`)
        }}
      />
      <div class="xl:ml-6">
        {data.map((d, i) => (
          <div class="h-8 mb-1.5 items-center flex">{currencyFormatter(Math.abs(d.amount))}</div>
        ))}
      </div>
    </div>
  )
}
